import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { lockBodyScroll, unlockBodyScroll } from '../../helpers/bodyScrollLock';
import BackdropOverlay, { OverlayType } from '../backdropOverlay/backdropOverlay';
import styles from './modal.module.pcss';

interface ModalProps {
  isOpen: boolean;
  onOverlayClick: () => void;
  children: React.ReactElement | React.ReactElement[];
  skipRemovingModalRoot?: boolean;
}

const modalRoot = document.createElement('div');
export const ANIMATION_DURATION = 350;

function Modal({ children, isOpen, onOverlayClick, skipRemovingModalRoot = false }: ModalProps): React.ReactElement {
  useEffect(() => {
    document.body.appendChild(modalRoot);

    return (): void => {
      if (document.body.contains(modalRoot) && !skipRemovingModalRoot) {
        document.body.removeChild(modalRoot);
      }
    };
  }, []);

  useEffect(() => {
    if (isOpen) {
      lockBodyScroll(false, true);
    } else {
      unlockBodyScroll(true);
    }
  }, [isOpen]);

  function handleBlur(e: React.FocusEvent<HTMLInputElement>): void {
    const insideModal = (e.relatedTarget as HTMLElement)?.closest(`.${styles.modal}`);
    const insideDocument = (e.relatedTarget as HTMLElement)?.closest('html');
    if (!insideModal && insideDocument) {
      onOverlayClick();
    }
  }

  return createPortal(
    <div className={styles.modal} onBlur={handleBlur}>
      <BackdropOverlay open={isOpen} handleClose={onOverlayClick} type={OverlayType.LIGHT} />
      {children}
    </div>,
    modalRoot
  );
}

export default Modal;
